module.exports = __webpack_public_path__ + "media/images/countryrect/uz-218e75994db3f618688edc576c0c8ec8.svg";